<template>
    <div class="info-section">
      <div class="info-content">
        <img src="../../../src/assets/img/precios.png" alt="precios" class="img-precios" />
        <div class="row text-center">
          <div class="col-md-12 span-precios">
            <p>*TODOS LOS PRECIOS SON EN PESOS MEXICANOS Y CUENTAN CON IVA INCLUIDO*</p>
          </div>
          <div class="col-md-12 spacing-text">
            <p class="text-precios">Al contactar a nuestro agente Talentinus, podrás conocer las promociones especiales disponibles.</p>
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
            <a
                class="cta-button"
                href="https://api.whatsapp.com/send?phone=5215561461518&text=%C2%A1Quiero%20empezar%20mi%20diagn%C3%B3stico%20gratis!%F0%9F%98%80"
                target="_blank"
                rel="noopener"
                style="font-size: 14px;"
            >
                DESCUBRIR
            </a>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'InfoSection'
  }
  </script>

<style>
    .info-section {
        width: 100%;
        height: 900px;
        background-color: #000;
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        box-sizing: border-box;
    }
    
    .info-content {
        display: flex;
        max-height: 700px;
        flex-direction: column;
        align-items: center;
        gap: 24px;
        text-align: center;
    }

    .mistica-style-h3 {
        font-family: 'Open Sans', sans-serif;
        font-weight: 600;
        font-size: 64px;
        align-items: center;
        color: #C58911;
        padding-bottom: 5%;
        padding: 50px 80px;
        transform: scaleY(1.2);
    }

    .img-precios {
        width: 1008px;
        height: 424px;
        flex-shrink: 0;
        aspect-ratio: 126/53;
        margin-top: 80px;
    }

    .span-precios {
        color: #FFF;
        text-align: center;
        leading-trim: both;
        text-edge: cap;
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 137%; /* 19.18px */
        letter-spacing: -0.42px;
    }

    .text-precios {
        color: #FFF;
        text-align: center;
        leading-trim: both;
        text-edge: cap;
        font-family: Montserrat;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 119%; /* 28.56px */
    }   
    
    .spacing-text {
        padding-top: 50px;
    }

    @media (max-width: 768px) {
  .info-section {
    width: 100vw;
    min-width: 100vw;
    max-width: 100vw;
    height: auto;
    min-height: 180px;
    padding: 0;
    align-items: flex-start;
    overflow-x: hidden;
  }
  .info-content {
    width: 100vw;
    max-width: 100vw;
    min-width: 100vw;
    gap: 14px;
    padding: 0;
    box-sizing: border-box;
  }
  .img-precios {
    width: 100vw !important;
    max-width: 100vw !important;
    min-width: 100vw !important;
    height: auto !important;
    margin-top: 24px;
    display: block;
  }
  .span-precios {
    font-size: 11px;
    padding: 0 2vw;
    line-height: 1.2;
    box-sizing: border-box;
    width: 100vw;
    max-width: 100vw;
  }
  .text-precios {
    font-size: 15px;
    padding: 0 2vw;
    line-height: 1.25;
    box-sizing: border-box;
    width: 100vw;
    max-width: 100vw;
  }
  .spacing-text {
    padding-top: 18px;
  }
  .cta-button {
    font-size: 13px !important;
    padding: 10px 22px !important;
    width: auto;
    max-width: 90vw;
    box-sizing: border-box;
    margin-bottom: 32px; /* <-- Espacio debajo del botón en móvil */
  }
}
  </style>